import gql from "graphql-tag";

export const MY_TIMESHEET_UPDATE_TIMESHEET = gql`
  mutation updateMysheetTimesheet(
    $_id: String!
    $name: String!
    $description: String
    $startTime: Date
    $endTime: Date
    $projectId: String
    $clientId: String
    $costId: String
    $validFrom: Date
    $validTo: Date
  ) {
    updateMysheetTimesheet(
      _id: $_id
      name: $name
      description: $description
      startTime: $startTime
      endTime: $endTime
      projectId: $projectId
      clientId: $clientId
      costId: $costId
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      startTime
      endTime
      projectId
      clientId
      costId
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      state
    }
  }
`;
